import CustomerIds   from "../../customer/CustomerIds";
import Trail         from "../../fundamentals/trail/Trail";
import MailGroupId   from "./MailGroupId";
import MailGroupName from "./MailGroupName";

class MailGroup {
  constructor(
    private readonly _id: MailGroupId = new MailGroupId(),
    private readonly _name: MailGroupName = new MailGroupName(),
    private readonly _customerIds: CustomerIds = new CustomerIds(),
    private readonly _trail: Trail = new Trail(),
  ) {
  }

  get id() {
    return this._id;
  }

  get name() {
    return this._name;
  }

  get customerIds() {
    return this._customerIds;
  }

  get trail() {
    return this._trail;
  }
}

export default MailGroup;
